 /* globals urls, validate, themeObj, Grid, tippy, waitlistTooltip */
(function($) {

    // FILE USAGE POPUP - VR Upload Scans page
    if( $('#file-usage-popup').length ) {
        $.magnificPopup.open({
            items: {
                src: '#file-usage-popup',
                type: 'inline',
            },
            modal: true
        });

        //  close popup for staff training
        $(document).on('click', '#file-usage-popup-close', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    }


	// Load homepage courses if needed
	if ($('.home-courses .courses-list.loading').length ) {
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'get_homepage_courses_html'
			}
		}).done(function( response ){
			$('.home-courses .courses-list.loading')
				.removeClass('loading')
				.html(response.data);
		}).fail(function(){
			$('.home-courses .courses-list.loading')
				.removeClass('loading')
				.html('<p><em>No available seats. 2025 courses will be released in July.</em></p>');
		});
	}

	
	// Event handler to initialize tooltips within the specified container
	function initTooltips(event, containSelector){
		// Use the provided container selector if provided, otherwise assume this is specified as the initial page load
		var tooltipSelector = (containSelector ? containSelector+' ' : '');

		// Waitlist tooltips
		// Tell JSHint to ignore for linebreak issues now: https://github.com/jshint/jshint/issues/2528
		/* jshint laxbreak: true */
		var waitlistTooltipContent = (waitlistTooltip.content && waitlistTooltip.content.length <= 1000)
			? waitlistTooltip.content
			: '<a href="'+waitlistTooltip.link+'">Review your next steps</a>';
		tippy(tooltipSelector + '.waitlist-tooltip', {
			theme: 'light-border',
			content: waitlistTooltipContent,
			placement: 'bottom',
			interactive: true,
			allowHTML: true,
			appendTo: document.body,
		});
	}

	initTooltips();

	// Init tooltips when event triggered
	$('body').on('initTooltips', initTooltips);


    //share this job - classisfieds
    $('.js-copy-link').on('click', function(e) {
		e.preventDefault();

		var $url = window.location.href;
		var copyFrom = $(this).data('copy-from');

		if (copyFrom === 'href') {
			$url = $(this).attr('href');
		}

        navigator.clipboard.writeText($url);

		$(this).find('.tooltip').fadeIn().delay(1000).fadeOut();

	});
    //display application - classifieds single view
    $('.js-hidethis-shownext').on('click', function(e) {
        e.preventDefault();
        $(this).addClass('hidden').next().removeClass('hidden');
    });

	//Input Mask those Date fields!
	$('.date-mask').mask('0000-00-00');

	$.maskFields = function() {
		//Input Mask those fields!
		$('.date-mask').mask('00/00/0000', {clearIfNotMatch: true});
		$('.date-mask-short').mask('00/00', {clearIfNotMatch: true});
		$('.date-mask-cc-long').mask('00/0000', {clearIfNotMatch: true});
		$('.cc-mask').mask('0000 0000 0000 0999', {clearIfNotMatch: true});
	};
	
	// Implement jquery spinner funcitonality for quantity spinners (i.e. fancy number inputs)
	// See https://github.com/vsn4ik/jquery.spinner
	$('.kois-quantity-spinner')
		// Doing this to turn off the plugin's "click and hold" functionality which can bug out in certain cases
		.on('mousedown', '[data-spin="up"], [data-spin="down"]', function(e){
			// If the event is a mousedown, kill it so no other events can take place
			e.stopImmediatePropagation();
		})
		.spinner();

	//wrap select elements in div for custom styling
	//$('select').not('[multiple]').wrap('<div class="selectbox-container"></div>');
	$('select').not('[multiple]').not('.dont-wrap-me').wrap(function(index){
		var classList = $(this).attr('class');
		return '<div class="selectbox-container' + ( classList ? ' ' + classList : '' ) + '"></div>';
	});

	//make sure embedded videos fit the container (are responsive)
	$('.rtecontent').fitVids();

	//flexslider for default wordpress gallery
	$('.gallery.flexslider').flexslider({
		controlNav: 'thumbnails'
	});

	//ADD EXPANDER ICON, second level
	$('.main-nav > ul > li.menu-item-has-children > a').each(function(){
		if( $(this).next('ul').length ) {
			$(this).append('<span class="dropper"></span>');
			//$(this).removeAttr('href');
			//$(this).removeAttr('itemprop');
			$(this).addClass('dropper');
		}
	});

	//ADD EXPANDER ICON, third level 
	$('.main-nav > ul > li.menu-item-has-children > ul > li.menu-item-has-children > a').each(function(){
		if( $(this).next('ul').length ) {
			$(this).append('<span class="dropper"></span>');
			$(this).addClass('dropper');
		}
	});

	// Make nav menu nice & responsive
	$('.site-header nav').responsiveNav();
	$('.profile--banner').mobileAchievements();


	// Fix layout with second aside is present (shop page)
	if (($('aside.side-area').length) && ($('nav.side-nav').length)) {
		$('.main-content-area').addClass('has-left-sidebar has-right-sidebar');
	} else if (($('aside.side-area').length === 0) && ($('nav.side-nav').length)) {
		$('.main-content-area').addClass('has-left-sidebar');
	} else if (($('nav.side-nav').length === 0) && ($('aside.side-area').length)) {
		$('.main-content-area').addClass('has-right-sidebar');
	}

	// When the login form is submitted, validate the username and password instead of submitting
	// This handler will be unbound if the credentials are valid, and the form will be resubmitted (successfully)
	$( 'form#loginform' ).submit( function(e){

		// Clear out any previous error messages
		$('#login-form-message').html( '' );

		// Stop the form submission and run validate function
		e.preventDefault();
		validateUserLogin( $('#user_login').val(), $('#user_pass').val() );
		return false;
	});

	// Send AJAX request to validate that a given username and password are valid
	// If not, display a message to the user. If so, unbind the validation submit handler and resubmit to log the user is
	function validateUserLogin(strUsername, strPassword){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'validate_user_login',
				username: strUsername,
				password: strPassword
			}
		}).done(function( strResponseJson ){
			//console.log( strResponseJson );
			var objUserLoginStatus = $.parseJSON( strResponseJson );

			if( objUserLoginStatus.success !== true ){
				$('#login-form-message').html( objUserLoginStatus.message );
			}
			else{
				$( 'form#loginform' ).unbind("submit").submit();
			}
		});
	}

	// TODO: can this be removed?
	$( 'form#method_customer_profile_update' ).submit( function( e ){
		e.preventDefault();

		// Clear out any previous error messages
		$('#profile-form-message').html( '' );

		// Get the profile form data as an array
		var arrProfileData = $( this ).serializeArray();

		// Find all the profile form checkboxes which weren't checked, and add them to the data we're sending
		$( 'form#method_customer_profile_update input:checkbox:not(:checked)' ).each( function(){
			arrProfileData.push( { name: $( this ).prop( 'name' ), value : null } );
		});

		$.ajax({
			method: 'POST',
			// url: urls.ajax,
			data: {
				action: 'update_customer_profile',
				methodRecordId: $( '#customer_profile_field_RecordID' ).val(),
				profileData: arrProfileData
			}
		}).done(function( strResponseJson ){
			var objResponse = $.parseJSON( strResponseJson );
			console.log(objResponse);

			if( objResponse.message ){
				$('#profile-form-message').html( objResponse.message );
				$('html, body').animate({
					scrollTop: $("#profile-form-message").offset().top
				}, 2000);
			}
		});
	});

	// Adding resize debounced handling for
	// navigation and possible layout adjustments
	$(window).resize( $.debounce( 50, true, function(){
	})).resize( $.debounce( 50, false, function(){

		// Adding Secondary mobile accordions for Course details
		// Check to make sure we're in Tablet view or below
		if ($(window).width() <= 1249  ){
			// Multiple elements exist so lets apply this to each
			$('.mobile-trigger').each(function(){
				//unbind first to prevent build up on resizes
				$(this).unbind('touchstart, click').bind('touchstart, click', function() {
					// if 'mobile-collapsed' is hidden, expand it
					// else hide it again
					if ($(this).next().is(':visible')) {
						$(this).removeClass('panel-open');
						$(this).next().slideUp();
					} else {
						$(this).addClass('panel-open');
						$(this).next().slideDown();
					}
				});
			});
		} else {
			//remove jQuery applied inline styles to hide 'mobile-collapsed'
			$('.mobile-collapsed').removeAttr('style');
		}
		
	}));

	$(window).trigger('resize');

	//  staff training popup
	$('.btn-reg-staff-training-add').on('click', function() {

		
		//  reset form inputs
		$('#staff-training-modal-popup input[name=firstName]').val('');
		$('#staff-training-modal-popup input[name=lastName]').val('');
		$('#staff-training-modal-popup input[name=id]').val('');
		$('#staff-training-modal-popup input[name=username]').val('');
		$('#staff-training-modal-popup input[name=email]').val('');
		$('#staff-training-modal-popup input[name=Password]').val('');
		$('#staff-training-modal-popup input[name=PasswordConfirmation]').val('');
	});
	
	
	//	init popup for staff training
	$('#open-staff-training-modal-popup').magnificPopup({
		type: 'inline',
		preloader: false,
		modal: true
	});

	//  close popup for staff training
	$(document).on('click', '#close-staff-training-modal-popup', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

	//  save a new staff member and enroll them in the course
	$('#staff-training-modal-popup .btn-staff-training-save ').on('click', function() {

		//  check to see if the fields are valid
		var objValidationResult = validateStaffTrainingRegistration();

		$( this ).addClass('loading').addClass('c-btn--disabled').prop('disabled',true);
		if(!objValidationResult){
			enrollStaffMember();
		}
		// objValidationResult exists and isn't a Promise. Validation has failed, show the relevant errors
		else if(objValidationResult && !objValidationResult.isPromise){
			showStaffRegistrationErrors(objValidationResult);
		}
		else{
			// We got a Promise back. Wait for async validation to finish
		}
		
	});

	// ajax call to enroll a staff member in a training course
	function enrollStaffMember() {
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'add_staff_training_user',
				firstName: $('#staff-training-modal-popup input[name=firstName]').val(),
				lastName: $('#staff-training-modal-popup input[name=lastName]').val(),
				userName: $('#staff-training-modal-popup input[name=username]').val(),
				email: $('#staff-training-modal-popup input[name=email]').val(),
				password: $('#staff-training-modal-popup input[name=Password]').val(),
				subscriptionId: $('#staff-training-modal-popup input[name=subscriptionId]').val(),
				staffMethodProductId: $('#staff-training-modal-popup input[name=staffMethodProductId]').val(),
			}
		}).done(function( response ){
			if(response.success) {
				$.magnificPopup.close();
				$('.staff_training_table')
					.html(response.data);
				bind_staff_training_table_links();
				$('#staff-training-modal-popup .btn-staff-training-save ').removeClass('loading').removeClass('c-btn--disabled').prop('disabled',false);
			}else {
				$('#staff-training-modal-popup .message-target').html(response.data.message);
				$('#staff-training-modal-popup .btn-staff-training-save ').removeClass('loading').removeClass('c-btn--disabled').prop('disabled',false);
			}
		}).fail(function(response){
			$('#staff-training-modal-popup .message-target').html(response.data.message);
			$('#staff-training-modal-popup .btn-staff-training-save ').removeClass('loading').removeClass('c-btn--disabled').prop('disabled',false);
		});
	}

	// Displays validation errors to the user based on the current step
	function showStaffRegistrationErrors(objValidationResult){
		// Make AJAX call to render the twig message partial with a generic error message
		$.ajax({
			method: "POST",
			url: urls.ajax,
			data: { action: 'generate_registration_error' }
		})
		.done(function( strResponse ) {
			var objResponse = $.parseJSON(strResponse);

			// Add the generic error message to the top of this step, and scroll the window there
			if(objResponse.success){
				$('#staff-training-modal-popup .message-target').html(objResponse.message);
			}
			// Highlight fields and add error messages based on objValidationResult
			addFieldValidationErrorStylesAndMessages(objValidationResult);

			//regFormAlreadyProcessing = false;
		});
	}
	// Add validation error messages for each input field, based on validation results
	function addFieldValidationErrorStylesAndMessages(objValidationResult){
		$.each(objValidationResult, function(key, value){
			var strErrorMessage = '<span class="validation-error">'+value[0]+'</span>';
			var el;
			el = $('input[name="'+key+'"]');
			el.addClass('error');
			el.prevAll('label').addClass('error');
			el.after(strErrorMessage);
		});
		$('#staff-training-modal-popup .btn-staff-training-save ').removeClass('loading').removeClass('c-btn--disabled').prop('disabled',false);
	}

	//staff training validation
	function validateStaffTrainingRegistration(){

		// Set up validation values and contraints
		var values = {
			firstName: $('#staff-training-modal-popup input[name=firstName]').val(),
			lastName: $('#staff-training-modal-popup input[name=lastName]').val(),
			username: $('#staff-training-modal-popup input[name=username]').val(),
			email: $('#staff-training-modal-popup input[name=email]').val(),
			Password: $('#staff-training-modal-popup input[name=Password]').val(),
			PasswordConfirmation: $('#staff-training-modal-popup input[name=PasswordConfirmation]').val()
		};
		var constraints = {
			firstName:{
				presence: {
					message: getValidationErrorMessage('FirstNameBlank')
				},
				length: {
		      		maximum: 25,
		      		tooLong: getValidationErrorMessage('FirstNameTooLong', {max: 25})
				},
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: getValidationErrorMessage('FirstNameFormat')
				}
			},
			lastName:{
				presence: {
					message: getValidationErrorMessage('LastNameBlank')
				},
				length: {
		      		maximum: 25,
		      		tooLong: getValidationErrorMessage('LastNameTooLong', {max: 25})
				},
				format: {
					pattern: /^(?=.*[A-Z])(?=.*[a-z]).*$/gm,
					message: getValidationErrorMessage('LastNameFormat')
				}
			},
			username: {
				presence: {
					message: getValidationErrorMessage('UsernameBlank')
				},
			  	length: {
					maximum: 41,
					tooLong: getValidationErrorMessage('UsernameTooLong', {max: 41})
				},
				format: {
					// User ID can only contain letters and numbers
					pattern: '^[a-zA-Z0-9]+',
					message: getValidationErrorMessage('UsernameFormat')
				}
			},
			email: {
				presence: {
					message: getValidationErrorMessage('EmailBlank')
				},
				email: {
					message: getValidationErrorMessage('EmailFormat')
				}
			},
			Password: {
				presence: {
					message: getValidationErrorMessage('PasswordBlank')
				},
				format: {
					pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/, // Password must be at least 8 characters, including at least 1 lowecase letter, 1 uppercase letter, and 1 digit
					message: getValidationErrorMessage('PasswordFormat')
				}
			},
			PasswordConfirmation: {
				equality: {
					attribute: 'Password',
					message: getValidationErrorMessage('PasswordConfirmationNotEqual')
				},
				presence: {
					message: getValidationErrorMessage('PasswordConfirmationBlank')
				}
			}
		};

		// Perform validation
		var objValidationResult = validate(values, constraints);

		// If basic validation passed, perform async validation to make sure the username and email are still available
		if(!objValidationResult){
			objValidationResult = checkUsernameAndEmailAvailability();
		}

		// Return the validation result (or Promise, in the case of checkUsernameAndEmailAvailability)
		return objValidationResult;
	}
	// Perform an asynchronous validation of the user's chosen username and email to make sure they're available
	function checkUsernameAndEmailAvailability(){
		// On success, show the next step
		var success = function(){enrollStaffMember();};
		// On error, parse the resulting WP REST API response body to display relevant info for the impacted field(s)
		var error = function(error) {
			var objValidationError = {};
			if(error.code === 'both_exist'){
				objValidationError.username = ['This username is already taken'];
				objValidationError.email = ['This email is already taken'];
			}
			else if(error.code === 'email_exists'){
				objValidationError.email = ['This email is already taken'];
			}
			else if(error.code === 'username_exists'){
				objValidationError.username = ['This username is already taken'];
			}
			else{
				objValidationError.username = [error.message];
				objValidationError.email = [error.message];
			}
			showStaffRegistrationErrors(objValidationError);
		};

		// Set up validation values and contraints
		var asyncValues = {
			usernameAndEmail: {
				username: $('#staff-training-modal-popup input[name=username]').val(),
				email: $('#staff-training-modal-popup input[name=email]').val()
			}
		};
		var asyncConstraints = {
			usernameAndEmail: {userAsyncValidator: true}
		};

		// Perform async validation, passing success and error handlers to the resulting Promise to be run once it has been settled
		var promise = validate.async(asyncValues, asyncConstraints).then(success, error);

		// Wrap promise in an object with a simple flag so Promise objects are easily distinguishable from validation error objects
		return {isPromise: true, promise: promise};
	}

	var getValidationErrorMessage = function(phraseKey, data) {
		var validationString =  validationMessages[phraseKey];

		for (var key in data) {
			validationString = validationString.replace('{'+key+'}', data[key]);
		}

		return validationString;
	};
	// Validation message
	var validationMessages = {
		UsernameBlank: "can't be blank",
		UsernameFormat: "is invalid",
		UsernameTooLong: "cannot exceed {max} characters",
		EmailBlank: "can't be blank",
		EmailFormat: "is not a valid email",
		PasswordBlank: "can't be blank",
		PasswordFormat: "is invalid",
		PasswordConfirmationBlank: "can't be blank",
		PasswordConfirmationNotEqual: "is not equal to password",
		FirstNameBlank: "can't be blank",
		FirstNameTooLong: "cannot exceed {max} characters",
		FirstNameFormat: "cannot be all upper or lower case",
		LastNameBlank: "can't be blank",
		LastNameTooLong: "cannot exceed {max} characters",
		LastNameFormat: "cannot be all upper or lower case",
	};

	//  bind staff training links to reactivate old staff members
	function bind_staff_training_table_links() {
		$('.staff_training_table a.staff-training-reactivate').on('click', function() {
			$('.loader-container').show();
			$.ajax({
				method: 'POST',
				url: urls.ajax,
				data: {
					action: 'reactivate_staff_training_user',
					user: $( this ).data('user'),
					staffMethodProductId: $(this).data('product'),
					subscriptionId: $('#staff-training-modal-popup input[name=subscriptionId]').val(),
				}
	
			}).done(function( response ){
				if(response.success) {
					$('.staff_training_table')
					.html(response.data);
					bind_staff_training_table_links();
					$('.loader-container').hide();
					$('#staff-training-row-container .message-target').html('');
				}else {
					$('#staff-training-row-container .message-target').html(response.data.message);
					$('.loader-container').hide();
				}
				$('.staff-progress-link').on('click', getStaffProgressDataClicked);
				
			}).fail(function(response){
				$('#staff-training-row-container .message-target').html(response.data.message);
				$('.loader-container').hide();
			});
		});
		$('.staff-progress-link').on('click', getStaffProgressDataClicked);
	}
	bind_staff_training_table_links();

	//	localization popup
	var siteLanguage = $('#localization-modal-popup').data('language');
	if(siteLanguage) {
		
		//	get 'seen' state from localstorage
		var seen = window.localStorage.getItem('localizationPopupSeen_'+siteLanguage);

		//	if not yet seen
		if(seen !== '1') {

			//	init popup
			$('.open-localization-modal-popup').magnificPopup({
				type: 'inline',
				preloader: false,
				modal: true
			});
			$(document).on('click', '.popup-modal-dismiss', function (e) {
				e.preventDefault();
				$.magnificPopup.close();
			});

			//	open popup
			$('.open-localization-modal-popup').click();

			//	store 'seen' state in localstorage
			window.localStorage.setItem('localizationPopupSeen_'+siteLanguage, '1');
		}
	}

	$('.staff-progress-link').on('click', getStaffProgressDataClicked);
	$('.autoClickMeOnLoad').click();

	function getStaffProgressDataClicked() {
		var id = $(this).data('id');
		var nonce = $(this).data('nonce');
		var userId = $(this).data('user-id');
		var courseId = $(this).data('course-id');
		var subscriptionId = $('input[name=subscriptionId]').val();
		var staffMethodProductId = $('input[name=staffMethodProductId]').val();

		$('#staff-progress-'+id)
		.empty()
		.html("<img src='/wp-content/themes/kois-2017-web/img/ajax-loader.gif' border=0>");

		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'get_staff_progress',
				id: id,
				nonce: nonce,
				userId: userId,
				courseId: courseId,
				subscriptionId: subscriptionId
			}
		}).done(function( response ){

			var completed = response['data']['completedItems'];
			var required = response['data']['requiredItems'];

			if(required > 0 && required === completed) {
				$('#staff-progress-'+id)
					.empty()
					.html('<a href="/celetter/?staffMethodProductId='+staffMethodProductId+'&amp;staffUserRecordId='+id+'&amp;subscriptionId='+subscriptionId+'" target="_blank">CE Letter</a>');
			} else {
				var progress = 0;
				if(required > 0) {
					progress = completed / required;
				}
				$('#staff-progress-'+id)
					.empty()
					.html(completed+' of '+required+' units completed ('+Math.round(progress * 100)+'%)');
			}
				
		}).fail(function(){
			$('#staff-progress-'+id)
				.empty()
				.html('Unable to get data');
		});
	}


	//	maintenance popup

	//	get expiration date from localstorage
	var maintenanceSeenExpiration = window.localStorage.getItem('maintenanceSeenExpiration');
	var now = new Date();

	//	if not yet seen
	if(now.getTime() > maintenanceSeenExpiration) {
	
		//	init popup
		$('.open-maintenance-modal-popup').magnificPopup({
			type: 'inline',
			preloader: false,
			modal: true
		});
		$(document).on('click', '.popup-modal-dismiss', function (e) {
			e.preventDefault();
			
			//	store expiration date in localstorage on dismissal
			now.setDate(now.getDate() + 1);
			window.localStorage.setItem('maintenanceSeenExpiration', now.getTime());

			$.magnificPopup.close();
		});

		//	open popup
		$('.open-maintenance-modal-popup').click();
	}

	//	init popup
	$('.open-member-status-popup').magnificPopup({
		type: 'inline',
		preloader: false,
		closeOnContentClick: false,
		closeOnBgClick: true,
		showCloseBtn: false
	});
	$(document).on('click', '.member-status-popup-dismiss, .timeout-popup-modal-dismiss', function (e) {
		$.magnificPopup.close();
	});

	//	init popup: session timeout
	$('.open-timeout-modal-popup').magnificPopup({
		type: 'inline',
		preloader: false,
		modal: true
	});

	//	open popup: session timeout
	$('.open-timeout-modal-popup').click();

})(jQuery);

/* Classifieds */

(function($, validatejs) {

	// Detect access level
	let isClassifieds = document.body.querySelector('section.main-content-area[data-has-access]');
	let isSignedIn = $('section.main-content-area').data('is-signed-in');
	let isAccessGranted = $('section.main-content-area').data('has-access');
	
	// Display prompt when applicable
	if (isClassifieds && !isSignedIn) {
		promptLogin();
	} else if (isClassifieds && !isAccessGranted) {
		promptAccessDenied();
	}

	// Make GF field read-only
	$('.gf_readonly input').attr('readonly', 'readonly');

	// Validate.js: job form constraints
	let constraintsJobForm = {
		post_title: {
			presence: true,
			noTags: true
		},
		job_description: {
			presence: true,
			noTags: true
		},
		address1: {
			noTags: true
		},
		address2: {
			noTags: true
		},
		city: {
			presence: true,
			noTags: true
		},
		state: {
			presence: true
		},
		zip_code: {
			noTags: true
		},
		country: {
			presence: true,
			noTags: true
		},
		region_optional: {
			noTags: true
		},
		specialty: {
			presence: true
		},
		job_type: {
			presence: true
		},
		send_to_select: {
			presence: true,
			email: true
		  },
		  agreement_of_terms: {
			presence: {
				message: 'is required'
			}
		},
		understand_expiration: {
			presence: {
				message: 'is required'
			}
		}
	};

	// Validate.js: practice form constraints
	let constraintsPracticeForm = {
		post_title: {
			presence: true,
			noTags: true
		},
		description: {
			presence: true,
			noTags: true
		},
		address1: {
			noTags: true
		},
		address2: {
			noTags: true
		},
		city: {
			presence: true,
			noTags: true
		},
		state: {
			presence: true
		},
		zip_code: {
			noTags: true
		},
		country: {
			presence: true,
			noTags: true
		},
		region_optional: {
			noTags: true
		},
		revenue: {
			presence: true
		},
		practice_associates: {
			presence: true
		},
		send_to: {
          presence: true,
          email: true
		},
		understand_expiration: {
			presence: {
				message: 'is required'
			}
		}
	};

	// State or region field: show/hide when page loaded
	let showStateFieldOnLoad = ['United States', 'Canada', '', null].includes($('select#country').val());

	toggleStateRegionFields(showStateFieldOnLoad);

	// Country field change event handler: show/hide state or region fields
	$('select#country').on('change', function() {
		let isStateFieldRequired = ['United States', 'Canada', '', null].includes(this.value);

		toggleStateRegionFields(isStateFieldRequired);

		// Clear out state field errors
		if (isStateFieldRequired) {
			$('input#region_optional').val('');
		} else {
			$('select#state').val('');
			hideError($('select#state')[0], null);
		}
	});

	// Button event handlers: add or edit listing
	$('form#job-listing-create button[type=submit]').on('click', { callAction: 'add_job_listing'}, addListing);
	$('form#practice-listing-create button[type=submit]').on('click', { callAction: 'add_practice_listing'}, addListing);

	function addListing(e) {

		e.preventDefault();

		// Reset form errors
		hideErrors();
		hideUpdateError();

		let formSelector = null;

		switch (e.data.callAction) {
			case 'add_job_listing':
				formSelector = 'form#job-listing-create';
				break;
			case 'add_practice_listing':
				formSelector = 'form#practice-listing-create';
				break;
		}

		let form = document.querySelector(formSelector);
		let objFormData = validatejs.collectFormValues(form);
		let errors = null;

		let isStateFieldRequired = ['United States', 'Canada', '', null].includes(objFormData.country);

		// Update constraints based on whether state field is required
		if (isStateFieldRequired) {
			constraintsJobForm.state.presence = true;
			constraintsPracticeForm.state.presence = true;
		} else {
			constraintsJobForm.state.presence = false;
			constraintsPracticeForm.state.presence = false;
		}

		if (e.data.callAction === 'add_job_listing') {
			errors = validatejs(objFormData, constraintsJobForm);
		} else if (e.data.callAction === 'add_practice_listing') {
			errors = validatejs(objFormData, constraintsPracticeForm);
		}

		if (!errors) {

			$('#job-listing-create button.listing-save, #practice-listing-create button.listing-save').prop('disabled', true).addClass('c-btn--disabled');

			// Make AJAX call to create new classifieds listing
			$.ajax({
				method: "POST",
				url: urls.ajax,
				data: { action: e.data.callAction, formData: objFormData }
			})
			.done(function(strResponse) {

				var objResponse = JSON.parse(strResponse);

				if (objResponse.success && objResponse.redirect_url) {
					window.location = objResponse.redirect_url;
				} else {
					// Scroll to the top of the page so the user can see error message
					showUpdateError(objResponse.message);
					window.scrollTo(0,0);
				}

				$('#job-listing-create button.listing-save, #practice-listing-create button.listing-save').prop('disabled', false).removeClass('c-btn--disabled');
			});
		} else {
			// Scroll to the top of the page so the user can see whatever message was returned
			showErrors(errors);
			window.scrollTo(0,0);
		}
	}

	// Hook up the inputs to validate on the fly
	let inputs = document.querySelectorAll('input, textarea, select');
	for (var i = 0; i < inputs.length; ++i) {
		inputs.item(i).addEventListener('change', function(ev) {
			let errors;

			switch(ev.target.nodeName) {
				case 'INPUT':
				case 'TEXTAREA':
					if (this.type === 'email') {
						errors = validatejs.single(ev.target.value, { presence: true, email: true, noTags: true });
					} else {
						errors = validatejs.single(ev.target.value, { presence: true, noTags: true });
					}
					break;
				case 'SELECT':
					errors = validatejs.single(ev.target.value, { presence: true });
					break;
			}

			hideError(this, errors);
		});
	}

	function hideError(ctrl, errors) {
		if(!errors || (ctrl.getAttribute('type') === 'checkbox' && ctrl.checked)) {
			$(ctrl).prevAll('label').removeClass('error');
			$(ctrl).removeClass('error warning');
			$(ctrl).next('span.validation-error').remove();
			$(ctrl).parent('div.dropdown').next('span.validation-error').remove();
			$(ctrl).parent('div.dropdown').next('span.validation-warning').remove();
			$(ctrl).parent('div.terms_ckbox.error, div.selectbox-container').next('span.validation-error').remove();
			$(ctrl).parent('div.selectbox-container.error').prevAll('label').removeClass('error');
			$(ctrl).parent('div.selectbox-container.error, div.terms_ckbox.error').removeClass('error');
		}

		if(ctrl.getAttribute('type') === 'checkbox' && ctrl.checked) {
			let isCheckedAgree = $('input#agree').is(':checked');
			let isCheckedExpire = $('input#expire').is(':checked');

			if(isCheckedAgree && isCheckedExpire) {
				$('div.terms_ckbox').prevAll('label').removeClass('error');
			}
		}
	}

	function hideErrors() {
		$('#listing-error-banner').hide();

		$('input.error, textarea.error, div.selectbox-container.error, div.terms_ckbox.error').each(function() {
			$(this).prevAll('label').removeClass('error');
			$(this).removeClass('error');
		});

		$('span.validation-error').remove();
	}

	function showErrors(errors) {
		$('#listing-error-banner').show();

		$.each(errors, function(key, value) {
			let el;
			let elContainer;
			let strErrorMessage;
			let applyOverrideCss = true;

			switch(key) {
				case 'post_title':
				case 'address1':
				case 'address2':
				case 'city':
				case 'zip_code':
				case 'send_to':
					el = $('input[name="' + key + '"]');
					break;
				case 'job_description':
				case 'description':
					el = $('textarea[name="' + key + '"]');
					break;
				case 'specialty':
				case 'job_type':
				case 'revenue':
				case 'practice_associates':
				case 'country':
				case 'state':
				case 'send_to_select':
					el = $('select[name="' + key + '"]');
					elContainer = el.parent('div.selectbox-container');
					break;
				case 'agreement_of_terms':
				case 'understand_expiration':
					el = $('input[name="' + key + '"]');
					elContainer = el.parent('div.terms_ckbox');
					applyOverrideCss = false;
					break;
			}

			if(el && elContainer) {
				if (applyOverrideCss) {
					strErrorMessage = '<span class="validation-error override">' + value[0] + '</span>';
				} else {
					strErrorMessage = '<span class="validation-error">' + value[0] + '</span>';
				}
				elContainer.addClass('error');
				elContainer.prevAll('label').addClass('error');
				elContainer.after(strErrorMessage);
			} else if(el) {
				strErrorMessage = '<span class="validation-error override">' + value[0] + '</span>';
				el.addClass('error');
				el.prevAll('label').addClass('error');
				el.after(strErrorMessage);
			}
		});
	}

	function showUpdateError(message) {
		$('#wp-error-message').html(message);
		$('#wp-error-banner').show();
	}

	function hideUpdateError() {
		$('#wp-error-message').html('');
		$('#wp-error-banner').hide();
	}

	function toggleStateRegionFields(showStateField) {
		if (showStateField) {
			$('sup#state_required').removeClass('hidden');
			$('select#state').parent().removeClass('hidden');
			$('input#region_optional').addClass('hidden');
		} else {
			$('sup#state_required').addClass('hidden');
			$('select#state').parent().addClass('hidden');
			$('input#region_optional').removeClass('hidden');
		}
	}

	// Button event handlers: delete listing from dashboard
	$('a[href="#delete-job"]').on('click', { source: '#delete-listing-popup' }, openListingDeleteDialog);
	$('a[href="#delete-practice"]').on('click', { source: '#delete-listing-popup' }, openListingDeleteDialog);
	$('a[href="#cancel-delete-listing"]').on('click', (e) => {
		closeConfirmDialog(e, '#btn-delete-listing', '#delete-listing-message');
	});
	$('#btn-delete-listing').on('click', startAjaxToDeleteJobListing);

	function openListingDeleteDialog(e) {
		e.preventDefault();

		// Set listing URL and other data to the confirm delete dialog button
		$('#btn-delete-listing').data('href-action', $(this).attr('href'));
		$('#btn-delete-listing').data('listing', $(this).data('listing'));
		$('#btn-delete-listing').data('dashboard-list-row-id', $(this).data('dashboard-list-row-id'));

		if ($(this).attr('href') === '#delete-job') {
			$('#delete-listing-type').html('job');
		} else if ($(this).attr('href') === '#delete-practice') {
			$('#delete-listing-type').html('practice');
		}

		mpOpen(e.data.source);
	}

	function startAjaxToDeleteJobListing(e) {
		e.preventDefault();

		disableConfirmDialogButton('#delete-listing-popup a#btn-delete-listing');
		clearConfirmDialogMessage('#delete-listing-message');

		let deleteAction = $(this).data('href-action');
		let callAction = null;

		if (deleteAction === '#delete-job') {
			callAction = 'delete_job_listing';
		} else if (deleteAction === '#delete-practice') {
			callAction = 'delete_practice_listing';
		}

		let actionParams = { url: $(this).data('listing'), dashboard_list_row_id: $(this).data('dashboard-list-row-id') };

		classifiedsAJAX(callAction, actionParams);
	}

	function completeAjaxToDeleteJobListing(respObj) {

		enableConfirmDialogButton('#delete-listing-popup a#btn-delete-listing');

		if (respObj.success) {

			// Remove deleted listing from dashboard list
			$('#' + respObj.dashboard_list_row_id).remove();
			closeConfirmDialog(null, '#btn-delete-listing', '#delete-listing-message');
		} else {

			// Handle error: show message on dialog
			$('#delete-listing-message').html(respObj.message);
		}

		if (!respObj.success && respObj.log_post) {
			console.log(respObj.log_post);
		}
	}

	function closeConfirmDialog(e, btnId, msgId) {
		if (e) {
			e.preventDefault();
		}

		// Reset dialog
		$(btnId).data('listing', '');
		$(msgId).html('');

		$.magnificPopup.close();
	}

	function disableConfirmDialogButton(btnId) {
		$(btnId).prop('disabled', true).addClass('c-btn--disabled');
	}

	function enableConfirmDialogButton(btnId) {
		$(btnId).prop('disabled', false).removeClass('c-btn--disabled');
	}

	function clearConfirmDialogMessage(msgId) {
		$(msgId).html('');
	}

	// Button event handlers: relist listing from dashboard
	$('a[href="#relist-job"]').on('click', { source: '#relist-listing-popup' }, openRelistDialog);
	$('a[href="#relist-practice"]').on('click', { source: '#relist-listing-popup' }, openRelistDialog);
	$('a[href="#cancel-relist-listing"]').on('click', (e) => {
		closeConfirmDialog(e, '#btn-relist-listing', '#relist-listing-message');
	});
	$('#btn-relist-listing').on('click', startAjaxToReListJobListing);

	function openRelistDialog(e) {
		e.preventDefault();

		// Set listing URL and other data to the confirm relist dialog button
		$('#btn-relist-listing').data('href-action', $(this).attr('href'));
		$('#btn-relist-listing').data('listing', $(this).data('listing'));
		$('#btn-relist-listing').data('dashboard-list-row-id', $(this).data('dashboard-list-row-id'));

		if ($(this).attr('href') === '#relist-job') {
			$('#relist-listing-type').html('job');
		} else if ($(this).attr('href') === '#relist-practice') {
			$('#relist-listing-type').html('practice');
		}

		mpOpen(e.data.source);
	}

	function startAjaxToReListJobListing(e) {
		e.preventDefault();

		disableConfirmDialogButton('#relist-listing-popup a#btn-relist-listing');
		clearConfirmDialogMessage('#relist-listing-message');

		let relistAction = $(this).data('href-action');
		let callAction = null;

		if (relistAction === '#relist-job') {
			callAction = 'relist_job_listing';
		} else if (relistAction === '#relist-practice') {
			callAction = 'relist_practice_listing';
		}

		let actionParams = { url: $(this).data('listing'), dashboard_list_row_id: $(this).data('dashboard-list-row-id') };

		classifiedsAJAX(callAction, actionParams);
	}

	function completeAjaxToReListJobListing(respObj) {

		enableConfirmDialogButton('#relist-listing-popup a#btn-relist-listing');

		if (respObj.success) {

			// Refresh relisted listing in dashboard list
			refreshDashboardActionButtons('#' + respObj.dashboard_list_row_id, respObj.relist_date);
			closeConfirmDialog(null, '#btn-relist-listing', '#relist-listing-message');
		} else {

			// Handle error: show message on dialog
			$('#relist-listing-message').html(respObj.message);
		}

		if (!respObj.success && respObj.log_post) {
			console.log(respObj.log_post);
		}
	}

	function refreshDashboardActionButtons(dashboardListRowId, relistDate) {
		$(dashboardListRowId + ' .text.expired-on').addClass('hidden');
		$(dashboardListRowId + ' .text.expires-on').html('Expires on ' + relistDate).removeClass('hidden');
		$(dashboardListRowId + ' .icon-btn-link.relist-listing').addClass('hidden');
		$(dashboardListRowId + ' .icon-btn-link.view-listing').removeClass('hidden');
		$(dashboardListRowId + ' .icon-btn-link.js-copy-link').removeClass('hidden');
	}

	// Button event handlers: close job listing
	$('#close-job-listing-btn').on('click', { source: '#close-listing-popup' }, openDialogToCloseJobListing);
	$('#btn-cancel-close-listing').on('click', (e) => {
		closeConfirmDialog(e, '#btn-close-listing', '#close-listing-message');
	});
	$('#btn-close-listing').on('click', startAjaxToCloseJobListing);

	function openDialogToCloseJobListing(e) {
		e.preventDefault();

		// Set listing URL and other data to the confirm dialog button
		$('#btn-close-listing').data('listing', $(this).data('listing'));

		mpOpen(e.data.source);
	}

	function startAjaxToCloseJobListing(e) {
		e.preventDefault();

		disableConfirmDialogButton('#btn-close-listing');
		clearConfirmDialogMessage('#close-listing-message');

		let callAction = 'close_job_listing';
		let actionParams = { url: $(this).data('listing') };

		classifiedsAJAX(callAction, actionParams);
	}

	function completeAjaxToCloseJobListing(respObj) {

		enableConfirmDialogButton('#btn-close-listing');

		if (respObj.success) {
			$('#status-live').addClass('hidden');
			$('#status-closed').removeClass('hidden');
			$('#close-job-listing-btn').addClass('hidden');
			$('#open-job-listing-btn').removeClass('hidden');
			$('#btn-close-listing').addClass('hidden');
			$('#btn-open-listing').removeClass('hidden');
			$('#open-close-label').html('open');

			closeConfirmDialog(null, '#btn-close-listing', '#close-listing-message');
		} else {
			$('#close-listing-message').html(respObj.message);
		}

		if (!respObj.success && respObj.log_post) {
			console.log(respObj.log_post);
		}
	}

	// Button event handlers: open job listing
	$('#open-job-listing-btn').on('click', { source: '#close-listing-popup' }, openDialogToOpenJobListing);
	$('#btn-cancel-close-listing').on('click', (e) => {
		closeConfirmDialog(e, '#btn-open-listing', '#close-listing-message');
	});
	$('#btn-open-listing').on('click', startAjaxToOpenJobListing);

	function openDialogToOpenJobListing(e) {
		e.preventDefault();

		// Set listing URL and other data to the confirm dialog button
		$('#btn-open-listing').data('listing', $(this).data('listing'));

		mpOpen(e.data.source);
	}

	function startAjaxToOpenJobListing(e) {
		e.preventDefault();

		disableConfirmDialogButton('#btn-open-listing');
		clearConfirmDialogMessage('#close-listing-message');

		let callAction = 'open_job_listing';
		let actionParams = { url: $(this).data('listing') };

		classifiedsAJAX(callAction, actionParams);
	}

	function completeAjaxToOpenJobListing(respObj) {

		enableConfirmDialogButton('#btn-open-listing');

		if (respObj.success) {
			$('#status-live').removeClass('hidden');
			$('#status-closed').addClass('hidden');
			$('#close-job-listing-btn').removeClass('hidden');
			$('#open-job-listing-btn').addClass('hidden');
			$('#btn-close-listing').removeClass('hidden');
			$('#btn-open-listing').addClass('hidden');
			$('#open-close-label').html('close');

			closeConfirmDialog(null, '#btn-open-listing', '#close-listing-message');
		} else {
			$('#close-listing-message').html(respObj.message);
		}

		if (!respObj.success && respObj.log_post) {
			console.log(respObj.log_post);
		}
	}

	function classifiedsAJAX(actionName, actionParams) {

		// Make AJAX call to perform action on classifieds listing
		$.ajax({
			method: "POST",
			url: urls.ajax,
			data: { action: actionName, listing: actionParams }
		}).done(function(strResp) {

			let objResp = JSON.parse(strResp);

			switch(actionName) {
				case 'delete_job_listing':
				case 'delete_practice_listing':
					completeAjaxToDeleteJobListing(objResp);
					break;
				case 'relist_job_listing':
				case 'relist_practice_listing':
					completeAjaxToReListJobListing(objResp);
					break;
				case 'close_job_listing':
					completeAjaxToCloseJobListing(objResp);
					break;
				case 'open_job_listing':
					completeAjaxToOpenJobListing(objResp);
					break;
				case 'two':
					break;
			}
		}).fail(function(jqXHR, textStatus) {
			console.log('jqXHR:', jqXHR);
			console.log('textStatus:', textStatus);
		});
	}

	// Login prompt
	function promptLogin() {
		mpOpen('#access-popup');
	}

	// Access denied prompt
	function promptAccessDenied() {
		mpOpen('#access-denied-popup');
	}

	function mpOpen(srcElem) {
		$.magnificPopup.open({
			items: {
				src: srcElem,
				type: 'inline',
			},
			modal: true,
			alignTop: false,
			mainClass: 'mfp-blurred-bg mfp-fade'
		});
	}

	// Button event handlers: email to request more info for practice listing
	// Disable JS/WP version of feature : $('#request-more-practice-info').on('click', requestInfo);

	function requestInfo(e) {

		e.preventDefault();

		// Make AJAX call to send request for more info.
		$.ajax({
			method: "POST",
			url: urls.ajax,
			data: { action: 'request_more_info', listingData: { url: $(this).attr('href'), requestUserEmail: $('#user-email').val() } }
		})
		.done(function(strResponse) {

			var objResponse = JSON.parse(strResponse);

			if (!objResponse.success) {
				console.log(objResponse.log_post);
			}
		});
	}
	
})(jQuery, validate);

/* Custom Tab Functions */
function setActiveTabToFirst(){
	jQuery('.tab ul.tabs').addClass('active').not('.noDefault').find('> li:eq(0)').addClass('current');
	jQuery('.tabs_item:first-of-type').addClass('active');
}

function triggerTabClickByHash(possibleTabHash){
	// Grab any tabs using this hash as an id, but only keep the first
	var tabMatch = jQuery('.tab ul.tabs li a#' + possibleTabHash).first();

	// Do we have a match? Clicky clicky.
	if( tabMatch.length === 1 ){
		tabMatch.trigger('click');
	}
	// Hash doesn't match a tab on the page, set first tab to active
	else{
		setActiveTabToFirst();
	}
}

jQuery(document).ready(function($){
	Grid.init();
	$.maskFields();

	// Initiate Accordions!
	$('.accordion').accordion();

	// Adding tab functionality for navigation
	$('nav.main-nav .menu-item > a').focus( function () {
		$(this).siblings('ul').addClass('show');
	}).blur(function(){
		$(this).siblings('ul').removeClass('show');
	});

	// Tab functionality for sub menu
	$('nav.main-nav .menu-item ul a').focus( function () {
		$(this).parent().parent('ul').addClass('show');
	}).blur(function(){
		$(this).parent().parent('ul').removeClass('show');
	});

	if ($('.testimonials').length){
		$('.testimonials .flexslider').flexslider();
	}

	// TODO: This is code we apparently reuse from project to project.
	// We should convert it to a jQuery plugin, and add the ability to load the page with a specific tab active
	/* Custom tabs */
	$('.tab ul.tabs li a').click(function (g) {
		var tab = $(this).closest('.tab'),
			index = $(this).closest('li').index();

		tab.find('ul.tabs > li').removeClass('current');
		$(this).closest('li').addClass('current');

		tab.find('.tab_content').find('div.tabs_item').not('div.tabs_item:eq(' + index + ')').hide().removeClass('active');
		tab.find('.tab_content').find('div.tabs_item:eq(' + index + ')').show().addClass('active');

		g.preventDefault();

		$('.btn-social-add').on('click', function(e){
			e.preventDefault();
			if($('.social-network-block').length === 0) {
				$(this).html('Add Another Network');
			}
		});

		$('.btn-edu-add').on('click', function(e){
			e.preventDefault();
			if($('.edu-block').length === 0) {
				$(this).html('Add Another School');
			}
		});
	});

	// If a the current URL has a hash, check if it matches the id of a tab on the page. If so, trigger a click to activate
	if(window.location.hash){
		// Get the hash string without the #
		var possibleTabHash = window.location.hash.substring(1);
        console.log(possibleTabHash);
		// Attempt to set the matching tab to active, or the first tab if no match is found
		triggerTabClickByHash(possibleTabHash);
	}
	// Otherwise set the first tab to active
	else{
		setActiveTabToFirst();
	}

	// CUSTOM PRINT: Complete
	$('#custom-print').on('click', function(){
		//grab contents we want to print
		var prtContent = document.querySelector(".print-target");
		//set window for displaying printed information
		var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
		//include correct doctype & CSS for Print
		WinPrint.document.write('<!doctype html><html><link rel="stylesheet" href="' + themeObj.templateUrl + '/print.css" type="text/css" media="all">');
		WinPrint.document.write(prtContent.innerHTML + '</html>');
		WinPrint.document.close();
		WinPrint.focus();

		WinPrint.setTimeout(function(){
			WinPrint.print();
			// WinPrint.close();
		}, 500);
	});


	// CUSTOM WOOCOMMERCE CHECKOUT BLOCKS: In Progress
	// TODO? Turn into plugins? Clean this up cause it sucks? Do better - in general.

	$('.checkout-billing-edit-link').on('click', function(e){
		var $billBlock = $('.billing-edit-block');
		var $shipBlock = $('.shipping-edit-block');
		e.preventDefault();
		if (!$billBlock.is(':visible')) {
			$shipBlock.fadeOut();
			$billBlock.fadeIn();
		} else {
			$billBlock.fadeOut();
		}
	});

	$('.checkout-shipping-edit-link').on('click', function(e){
		var $billBlock = $('.billing-edit-block');
		var $shipBlock = $('.shipping-edit-block');
		e.preventDefault();
		if (!$shipBlock.is(':visible')) {
			$billBlock.fadeOut();
			$shipBlock.fadeIn();
		} else {
			$shipBlock.fadeOut();
		}
	});

	$('input[type=radio][name=credit-options]').change(function() {
    if (this.value === 'new') {
      $(this).parent().find('.expander').slideDown();
    }
    else if (this.value !== 'new') {
      $(this).parent().find('.expander').slideUp();
    }
  });


	$('input[type=radio][name=k-creds]').change(function() {
		if (this.value === 'full') {
			$(this).parent().find('.expander').slideUp();
			$(this).parent().find('.expander.payment-full').slideDown();
			$('.checkout-row .credit-agreement').addClass('hidden');
		}
		else if (this.value === 'deposit') {
			$(this).parent().find('.expander').slideUp();
			$(this).parent().find('.expander.payment-deposits').slideDown();
			$('.checkout-row .credit-agreement').removeClass('hidden');
		}
		else if (this.value === 'plan') {
			$(this).parent().find('.expander').slideUp();
			$(this).parent().find('.expander.payment-plan').slideDown();
			$('.checkout-row .credit-agreement').removeClass('hidden');
		}
	});

	$('.main-content-area').addClass('loaded');

	$(window).load(function() {
		$('.flexslider').flexslider();
	});

	 // Privacy Policy alert function
	$('#hide-policy-alert').on('click', function(e){
		 e.preventDefault();
		document.cookie='hidePrivacyPolicy=true; max-age=31536000';
		$('.privacy-message').slideUp();
	});
	// cookie for Waitlist alert
	$('#hide-waitlist-alert').on('click', function(e){
		e.preventDefault();
		document.cookie='hideWaitlistAlert=true; max-age=86400';
		$('.waitlist-message').slideUp();
	});
	// cookie for WWYD alert
	$('#hide-wwyd-alert').on('click', function(e){
		e.preventDefault();
		document.cookie='hideWwydAlert=true; max-age=86400';
		$('.wwyd-message').slideUp();
	});
	// cookie for nft alert
	$('#hide-nft-alert').on('click', function(e){
		e.preventDefault();
		document.cookie='hideNftAlert=true; max-age=86400';
		$('.nft-message').slideUp();
	});
	// cookie for 165 announcement
	$('#hide-165-announcement').on('click', function(e){
		e.preventDefault();
		document.cookie='hide165Announcement=true; max-age=31536000';
		$('.165-announcement').slideUp();
	});
	// cookie for primary curriculum update
	$('#hide-primary-curriculum-update-announcement').on('click', function(e){
		e.preventDefault();
		document.cookie='hidePrimaryCurriculumUpdateAnnouncement=true; max-age=31536000';
		$('.primary-curriculum-update-announcement').slideUp();
	});
	// cookie for primary curriculum update acknowledgement
	$('#primary-curriculum-course-update-acknowledgement-button').on('click', function(e){
		document.cookie='hidePrimaryCurriculumUpdatePopup=true; path=/; max-age=31536000';
	});

	$('.popup-modal-yay').magnificPopup({
		type: 'inline',
		preloader: false,
		modal: true
	});

	$(document).on('click', '.popup-modal-yay-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

	// Listen for postMessage events from iframe
	window.addEventListener('message', function(event) {
		// Check if the message is an addToCart action
		if (event.data && event.data.type === 'addToCart') {
			// Extract course data from the message
			var courseData = event.data.data || {};
			
			var ajaxData = {
				action: 'reserve_course_seat',
				...courseData
			};
			
			// Make AJAX call to reserve_course_seat
			$.ajax({
				method: 'POST',
				url: urls.ajax,
				data: ajaxData
			}).done(function(response) {
				// Handle success - notify the iframe
				if (event.source && response.success) {
					event.source.postMessage({
						type: 'addToCartResponse',
						data: {
							...response,
							message: "Course successfully added to cart."
						}
					}, event.origin);
				} else if (event.source) {
					event.source.postMessage({
						type: 'addToCartResponse',
						data: {
							message: response.message || "An error occurred while adding the course to the cart."
						}
					}, event.origin);
				}
			}).fail(function(xhr, status, error) {
				// Handle error - notify the iframe of failure
				if (event.source) {
					event.source.postMessage({
						type: 'addToCartResponse',
						error: {
							status: xhr.status,
							statusText: status,
							error: error,
							responseText: xhr.responseText
						}
					}, event.origin);
				}
			});
		}
	});
});

function generateId(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      	result += characters.charAt(Math.floor(Math.random() * charactersLength));
   	}
   	return result;
}

